import { render, staticRenderFns } from "./EhrStudentOtherDropdown.vue?vue&type=template&id=fb2148ba&scoped=true&lang=pug"
import script from "./EhrStudentOtherDropdown.vue?vue&type=script&lang=js"
export * from "./EhrStudentOtherDropdown.vue?vue&type=script&lang=js"
import style0 from "./EhrStudentOtherDropdown.vue?vue&type=style&index=0&id=fb2148ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2148ba",
  null
  
)

export default component.exports